import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { AppSwitcherEntity, ExternalAppLink, ExternalAppSource } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/switcher' }, ServiceProxyMap.ANS);

export async function fetchExternalAppLinks(
  entity: AppSwitcherEntity,
  id: string,
  sourceSystem?: ExternalAppSource
): Promise<ExternalAppLink[]> {
  const response = await client.get(`/${entity}/${id}`, {
    params: {
      sourceSystem,
    },
  });
  return response.data;
}
